import { Alerts } from 'constants/alerts';
import { Role } from 'constants/roles';

import { useApiContext } from 'context/apiContext';
import { usePermissions } from 'hooks/usePermissions';

export function useProviderAccountsAccess() {
  const { user } = useApiContext();
  const { isHaveRole } = usePermissions();

  const hasProviderAccess = !user.alerts.includes(Alerts.EmptyProviderAccountAccess);

  return {
    isFinanceLeadWithProviderAccess: isHaveRole([Role.FinanceLead]) && hasProviderAccess,
    hasActionsAccess: hasProviderAccess,
  };
}
